import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-sidebar-link',
  template: `
    <div class="mb-1">
      @if (!isExternal()) {
        <a
          [routerLink]="routerLink()"
          routerLinkActive="bg-gray-100"
          #rla="routerLinkActive"
          [class]="linkClasses()"
        >
          <ng-container
            *ngTemplateOutlet="linkContent; context: { isActive: rla.isActive }"
          ></ng-container>
        </a>
      } @else {
        <a [href]="href()" [target]="target()" [class]="linkClasses()">
          <ng-container
            *ngTemplateOutlet="linkContent; context: { isActive: false }"
          ></ng-container>
        </a>
      }

      <ng-template #linkContent let-isActive="isActive">
        <div class="flex items-center gap-x-3.5">
          @if (icon()) {
            <i
              [class]="'fal fa-' + icon() + ' fa-fw text-base'"
              [class.text-primary-600]="isActive"
            ></i>
          }
          <span class="translate-y-px" [class.text-primary-600]="isActive">{{
            label()
          }}</span>
          <ng-content></ng-content>
        </div>
      </ng-template>
    </div>
  `,
  styles: [],
  standalone: false,
})
export class SidebarLinkComponent {
  // Inputs
  label = input.required<string>();
  icon = input<string>();
  routerLink = input<string>();
  href = input<string>();
  target = input<string>();
  indent = input<boolean>(false);

  // Computed pour savoir si c'est un lien externe
  isExternal = computed(() => !!this.href());

  // Classes dynamiques
  linkClasses() {
    const baseClasses =
      'flex items-center py-2 rounded-lg hover:bg-gray-100 no-underline text-sm font-medium';
    const paddingClass = this.indent() ? 'pl-3 pr-2.5' : 'px-2.5';

    return `${baseClasses} ${paddingClass}`;
  }
}
